import { M8RateDTO } from 'services/production/types';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createM8RateDTO = (id: number): M8RateDTO => ({
  id,
  currency: 'USD',
  dateOn: '',
  value: 0,
  valueCurrency: 'USD',
  scale: 0,
});

export const createM8RateDTOMock = (): M8RateDTO => ({
  id: createUniqueRuntimeNumber(),
  currency: 'BYN',
  dateOn: new Date().toISOString(),
  value: 20,
  valueCurrency: 'USD',
  scale: 5,
});
